export enum PagePaginations {
  DIAGNOSTICS_PAGE = 'diagnosticsPage',
  PATIENTS_PAGE = 'patientsPage',
  SENT_CASE_PAGE = 'sentCasePage',
  RECEIVED_CASE_PAGE = 'receivedCasePage',
}
